/* eslint-disable @typescript-eslint/naming-convention */
import type { BrightcoveVideo } from '@ps/web-martech-cms-types';
import React from 'react';

import styles from './CMSBrightcoveVideo.scss';

const CMSBrightcoveVideo: React.FC<BrightcoveVideo> = ({ video_id, player_id }) => (
  <div className={styles.video}>
    <div className={styles.videoWrap}>
      <iframe
        className={styles.videoIframe}
        src={`//players.brightcove.net/2132626462001/${player_id}/index.html?videoId=${video_id}`}
        allowFullScreen
      />
    </div>
  </div>
);

export default CMSBrightcoveVideo;
